'use client';
import React from 'react';
import Hooks from '@benzinga/hooks';
import { GeoData } from './entities';
import { GeoManager } from '@benzinga/geo-manager';
import { SessionContext } from '@benzinga/session-context';

declare const global: {
  geoip: (json: any) => void;
  geo: GeoData;
};

export const GeoTracker: React.FC = () => {
  const session = React.useContext(SessionContext);

  Hooks.useEffectDidMount(() => {
    const fetchGeo = async () => {
      const geoManager = session.getManager(GeoManager);
      const geo = await geoManager.getGeoLocation();
      if (geo.ok) {
        global.geo = geo.ok;
        const event = new Event('geo');
        window.dispatchEvent(event);
        setTimeout(() => {
          window.dispatchEvent(event);
        }, 500);
      }
    };
    if (!global.geo) {
      fetchGeo();
    }
  });

  return null;
};
